import { createSelector } from 'reselect';
import pageSelector from 'common/selectors/pageSelector';
import heroSelector from 'common/selectors/heroSelector';
import selectedContentSelector from 'common/selectors/selectedContentSelector';
import { isEmpty } from 'lib/util';

/**
 * This selector determines which content should be used for the intial embed.
 * If there a piece of content is selected, use that, otherwise use the hero
 */
export default createSelector(
    pageSelector,
    heroSelector,
    selectedContentSelector,
    ({ isFinal }, hero, selectedContent) => {
        // NOTE: When the selectedContent/heroContent type is `vod`, we want to allow playback.
        // This will allow Domestic & International VODs to play
        if (!isEmpty(selectedContent) &&
            typeof selectedContent.type === 'string' &&
            selectedContent.type.trim().toLowerCase() === 'vod') {
            return selectedContent;
        }

        if (!isEmpty(hero) && typeof hero.type === 'string' && hero.type.trim().toLowerCase() === 'vod') {
            return hero;
        }

        if (!isFinal) {
            return null;
        }

        return !isEmpty(selectedContent) ? selectedContent : hero;
    }
);



// WEBPACK FOOTER //
// ./app/common/selectors/initialEmbedSelector.js